// extracted by mini-css-extract-plugin
module.exports = {"socialsList":"styles_socialsList__eFqKg","socialsListItem":"styles_socialsListItem__3N3bX","credentials":"styles_credentials__70Sza"};